import { GTM_EVENTS_NAME } from './constant'
import { Money } from '@afterpay/types'

declare global {
  interface Window {
    dataLayer?: Array<Record<string, any>>
  }
}

export const setDataLayer = (event: string, data?: object): void => {
  window.dataLayer = window?.dataLayer ?? []
  window?.dataLayer?.push({
    event,
    ...data,
  })
}

export const sendPurchaseEvent = (transactionId: string, isFirstPurchase: boolean, purchaseAmount?: Money): void => {
  const data = {
    transaction_id: transactionId,
    ...(purchaseAmount?.amount !== undefined && { value: purchaseAmount.amount }),
    ...(purchaseAmount?.currency !== undefined && { currency: purchaseAmount.currency }),
  }

  setDataLayer(GTM_EVENTS_NAME.PURCHASE, data)

  if (isFirstPurchase) {
    setDataLayer(GTM_EVENTS_NAME.FIRST_PURCHASE, data)
  }
}
